import { i18nFunct } from '@lucid/gatsby-theme-lucid';
import { graphql, useStaticQuery } from 'gatsby';
import { VideoPlayButton } from 'lucid-components-react';
import React, { useContext } from 'react';

import LayoutContext from '../../contexts/layoutContext';
import { Drupal_ParagraphEnterpriseVideo } from '../../generated/graphql';
import './enterprise-video.scss';
import LazyLoad from 'react-lazyload';

interface EnterpriseVideoProps {
  fields?: Drupal_ParagraphEnterpriseVideo;
}

const EnterpriseVideo = ({ fields }: EnterpriseVideoProps) => {
  const { i18nData } = useStaticQuery(
    graphql`
      {
        i18nData: allFile(filter: { sourceInstanceName: { eq: "i18n" } }) {
          edges {
            node {
              name
              childSrcJson {
                mktg_ct_enterprise_pearson_header
                mktg_ct_enterprise_pearson_large_quote
                mktg_ct_enterprise_pearson_pitch
              }
            }
          }
        }
      }
    `
  );

  const filterFields = (items: Drupal_ParagraphEnterpriseVideo) => {
    return Object.keys(items)
      .filter(item => items[item as keyof Drupal_ParagraphEnterpriseVideo])
      .reduce(
        (res, item) => (
          (res[item] = items[item as keyof Drupal_ParagraphEnterpriseVideo]),
          res
        ),
        {} as {
          [key: string]: string;
        }
      );
  };

  const {
    language: { i18nKey },
    video: { getVideoModal }
  } = useContext(LayoutContext);

  const i18n = i18nFunct(i18nData, i18nKey);
  const defaults = {
    fieldVideoBackgroundImage:
      'https://d2slcw3kip6qmk.cloudfront.net/marketing/pages/chart/customers/pearson-quote2-700x360.jpg',
    fieldVideoLink:
      'https://player.vimeo.com/video/98592765?title=0&byline=0&portrait=0&autoplay=1',
    fieldTitle: i18n('mktg-ct-enterprise-pearson-header'),
    fieldQuote: i18n('mktg-ct-enterprise-pearson-large-quote'),
    fieldText: i18n('mktg-ct-enterprise-pearson-pitch')
  };

  let values = fields || defaults;

  if (fields && fields.fieldUseDefaults) {
    const filteredFields = filterFields(fields);
    values = { ...defaults, ...filteredFields };
  }

  return (
    <section className="enterprise-video">
      <LazyLoad offset={200}>
        <div
          className="enterprise-video__video"
          style={{
            backgroundImage: `url(${values.fieldVideoBackgroundImage})`
          }}
        >
          {values.fieldVideoLink && (
            <div className="enterprise-video__button-container">
              <VideoPlayButton
                size="lg"
                onClick={() => getVideoModal(values.fieldVideoLink!)}
              />
            </div>
          )}
        </div>
      </LazyLoad>
      <div className="enterprise-video__text">
        {values.fieldTitle && (
          <h2 className="enterprise-video__text-title">{values.fieldTitle}</h2>
        )}
        {values.fieldQuote && (
          <p className="enterprise-video__text-quote">{values.fieldQuote}</p>
        )}
        {values.fieldText && (
          <p className="enterprise-video__text-pitch">{values.fieldText}</p>
        )}
      </div>
    </section>
  );
};

export default EnterpriseVideo;
